import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

export const fetchMachineMaster = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.MACHINE_MASTER.LIST, {
        params: {
            limit,
            page_no,
            ...filter
        }
    });
}

export const fetchMachineMasterDropdown = (zone_id, is_active = true) => {
    const params = { is_active };
    if (zone_id) {
        params.zone_id = zone_id;
    }

    return axiosInstance.get(EndPoints.MACHINE_MASTER.LIST_DD, {
        params,
    });
}

export const createMachineMaster = (payload) => {
    return axiosInstance.post(EndPoints.MACHINE_MASTER.CREATE, payload)
}

export const updateMachineMaster = (payload) => {
    return axiosInstance.put(EndPoints.MACHINE_MASTER.UPDATE, payload)
}


export const deleteMachineMaster = (payload) => {
    const url = EndPoints.MACHINE_MASTER.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const downloadMachineMasterCSV = () => {
    return axiosInstance.put(EndPoints.MACHINE_MASTER.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}